export enum HTTPRequestMethods {
    GET = 'GET',
    POST = 'POST',
}
